export default {
  data() {
    return {
      INFINITY_ITEMS_COUNT_PER_LIST: 20,
      infinityScrollKey: +new Date(),
      infinityItemsCount: 0,
    }
  },

  computed: {
    infinityItemsCountPerList() {
      return this.INFINITY_ITEMS_COUNT_PER_LIST
    },

    infinityItems() {
      return []
    },

    infinityItemsPerList() {
      return this.infinityItems.slice(0, this.infinityItemsCount)
    },
  },

  watch: {
    infinityItems(value = [], oldValue = []) {
      if (value.length !== oldValue.length) {
        this.infinityItemsCount = this.infinityItemsCountPerList
        this.infinityScrollKey = +new Date()
        // TODO: scroll to top?
      }
    },
  },

  methods: {
    infinityScrollShowNext(entries, observer, isIntersecting) {
      if (isIntersecting && this.infinityItems.length > this.infinityItemsCount) {
        this.infinityItemsCount += this.infinityItemsCountPerList
      }
    },
  },
}
